import SELECT_TYPES from '../../constants/selectTypes';
import SelectField from '../SelectField';

const InputSelectField = (props) => (
  <SelectField selectType={SELECT_TYPES.WITH_INPUT} {...props} />
);

export default InputSelectField;
